import { dateFields } from '../../../../../utils/event/common';
import { views } from '../../../../../constants/event';

export const getViews = (group) =>
  dateFields.includes(group)
    ? [views.CHART, views.TABLE]
    : [views.COLUMN_CHART, views.TABLE, views.PIE_CHART];

export const getView = (currentView, result) => {
  const eventViews = getViews(result);
  return eventViews.includes(currentView) ? currentView : eventViews[0];
};
